import { usePullToRefresh } from "@hooks/usePullToRefresh";
import { getScrollableOverlayStore } from "@stores/scrollableOverlayStore";

export const PullToRefreshProvider = () => {
  usePullToRefresh({
    onRefresh: () => {
      window.location.reload();
    },
    shouldPullToRefresh: () => {
      const { isDealerContextSelectorOpen } = getScrollableOverlayStore();
      if (isDealerContextSelectorOpen) return false;
      // Same as pulltorefreshjs default: only allow when at top of page
      return window.scrollY === 0;
    },
  });

  return null;
};
